<div class="small">
    <div class="mx-5">
        <ul *ngIf="lngCode==='FR'">
            <li>
                Document en format <strong>PDF</strong> uniquement.
            </li>
            <li>
                1 seul(e) facture / avoir par <strong>PDF</strong> (si annexes, à scanner dans le même
                PDF)
            </li>
            <li>
                <strong>1 PDF</strong> par mail
            </li>
            <li>
                Typologie PDF: Nom du fichier 30 caractères maximum (exemple: référence facture)
            </li>
            <li>
                Transmission de factures lisibles (si possible éviter les couleurs foncées)
            </li>
            <li>
                Chaque document doit faire l'objet <strong>d'un seul envoi</strong>
            </li>
            <li>
                <strong>N° de commande obligatoire sur chaque document</strong>
            </li>
            <li>
                Document libellé à l'entité concernée et à l'adresse de facturation figurant sur le bon
                de
                commande
            </li>
        </ul>
        <ul *ngIf="lngCode==='EN'">
            <li>
                Document in PDF format only.
            </li>
            <li>
                Only 1 invoice/credit note per PDF (if attached, to be scanned in the same PDF) 
            </li>
            <li>
                1 PDF per email 
            </li>
            <li>
                PDF type: File name 30 characters maximum (example: invoice reference) 
            </li>
            <li>
                Transmission of legible invoices (if possible, avoid dark colours)
            </li>
            <li>
                Each document must be sent only once
            </li>
            <li>
                Order number required on each document 
            </li>
            <li>
                Document addressed to the relevant entity and billing address on the purchase order
            </li>
        </ul>
        <BR />
        <ul>
            <li>
                <strong *ngIf="lngCode==='FR'">Factures / Avoirs à envoyer à l'adresse électronique suivante selon la société facturée :</strong>
                <strong *ngIf="lngCode==='EN'">Invoices / Credit notes to be sent to the following email address depending on the invoiced company: </strong>
            </li>
        </ul>
        <div class="row">
            <div class="col-6">
                <table class="table table-sm table-bordered ml-3">
                    <thead>
                        <tr *ngIf="lngCode==='FR'">
                            <th>SOCIETE</th>
                            <th>SIREN</th>
                            <th>N° TVA INTRACOM</th>
                            <th>ADRESSE MAIL</th>
                        </tr>
                        <tr *ngIf="lngCode==='EN'">
                            <th>SOCIETY</th>
                            <th>SIREN</th>
                            <th>N° TVA INTRACOM</th>
                            <th>EMAIL ADDRESS</th>
                        </tr>
                    </thead>
                    <tr>
                        <td>ENDEL</td>
                        <td>438277030</td>
                        <td>FR79438277030</td>
                        <td rowspan="11"><a href="mailto://factures.fournisseurs@altradendel.com">factures.fournisseurs@altradendel.com</a>
                        </td>
                    </tr>
                    <tr>
                        <td>T.E.S</td>
                        <td>433062148</td>
                        <td>FR78433062148</td>
                        <!-- <td><a href="mailto://fac.pdf-csp.fours.tes@equans.com">fac.pdf-csp.fours.tes@equans.com</a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>TENEO</td>
                        <td>384335527</td>
                        <td>FR88384335527</td>
                        <!-- <td><a href="mailto://fac.pdf-csp.fours.teneo@equans.com">fac.pdf-csp.fours.teneo@equans.com</a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>Metal Control</td>
                        <td>347812281</td>
                        <td>FR95347812281</td>
                        <!-- <td><a
                                href="mailto://fac.pdf-csp.fours.metalcontrol@equans.com">fac.pdf-csp.fours.metalcontrol@equans.com</a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>Endel Navibord</td>
                        <td>404976243</td>
                        <td>FR55404976243</td>
                        <!-- <td><a
                                href="mailto://fac.pdf-csp.fours.endelnavibord@equans.com">fac.pdf-csp.fours.endelnavibord@equans.com</a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>SN Europipe</td>
                        <td>384724951</td>
                        <td>FR92384724951</td>
                        <!-- <td><a
                                href="mailto://fac.pdf-csp.fours.europipe@equans.com">fac.pdf-csp.fours.europipe@equans.com</a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>Endel Réunion</td>
                        <td>509064309</td>
                        <td>FR10509064309</td>
                        <!-- <td><a
                                href="mailto://fac.pdf-csp.fours.endelreunion@equans.com">fac.pdf-csp.fours.endelreunion@equans.com</a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>M.E.V.I</td>
                        <td>817389059</td>
                        <td>FR11817389059</td>
                        <!-- <td><a href="mailto://fac.pdf-csp.fours.mevi@equans.com">fac.pdf-csp.fours.mevi@equans.com</a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>ACE</td>
                        <td>351131149</td>
                        <td>FR37351131149</td>
                        <!-- <td><a href="mailto:/fac.pdf-csp.fours.ace@equans.com/">fac.pdf-csp.fours.ace@equans.com</a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>Endel SRA</td>
                        <td>830440327</td>
                        <td>FR56830440327</td>
                        <!-- <td><a
                                href="mailto://fac.pdf-csp.fours.endelsra@equans.com">fac.pdf-csp.fours.endelsra@equans.com</a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>Decalog</td>
                        <td>852912773</td>
                        <td>FR66852912773</td>
                        <!-- <td><a
                                href="mailto://fac.pdf-csp.fours.decalog@equans.com">fac.pdf-csp.fours.decalog@equans.com</a>
                        </td> -->
                    </tr>
                </table>

            </div>
        </div>
        <div class="text-danger">
            <h6>
                <strong *ngIf="lngCode=='FR'">Tout document envoyé à une autre adresse électronique ne sera pas traité.</strong>
                <strong *ngIf="lngCode=='EN'">Any documents sent to another email address will not be processed.</strong>
            </h6>
        </div>
    </div>

    <div class="mt-5 mb-3" style="width:100%; border-bottom:solid 1px red;">
        <h5>
            <strong *ngIf="lngCode=='FR'">INFORMATIONS IMPORTANTES</strong>
            <strong *ngIf="lngCode=='EN'">IMPORTANT INFORMATION</strong>
        </h5>
    </div>
    <div class="mx-5" *ngIf="lngCode=='FR'">
        <p><strong>Ne plus envoyer vos factures et avoirs par courrier</strong></p>
        <p><strong>L'envoi des factures et avoirs par mail concerne les entités listées ci-dessus</strong></p>
        <p><strong>Les relances doivent être envoyées à l'adresse : <a href="mailto://:relances-fournisseurs@altradendel.com">relances-fournisseurs@altradendel.com</a>
                (Téléphone : 02.72.25.88.23  le mardi et le jeudi de 9h à 12h)</strong></p>
    </div>
    <div class="mx-5" *ngIf="lngCode=='EN'">
        <p><strong>Stop sending your invoices and credit notes by post </strong></p>
        <p><strong>Invoices and credit notes are sent by email to the entities listed above</strong></p>
        <p><strong>Reminders must be sent to : <a href="mailto://:relances-fournisseurs@altradendel.com">relances-fournisseurs@altradendel.com</a> (Telephone : 02.72.25.88.23)</strong></p>
    </div>

    <div class="mt-5 mb-3" style="width:100%; border-bottom:solid 1px red;">
        <h5>
            <strong *ngIf="lngCode=='FR'">CONDITIONS GENERALES D'ACHATS ENDEL</strong>
            <strong *ngIf="lngCode=='EN'">ENDEL GENERAL TERMS AND CONDITIONS OF PURCHASE</strong>
        </h5>
    </div>
    <div class="mx-5" *ngIf="lngCode=='FR'">
        <p><em>« Il est rappelé qu’aux termes de l’article 242 noniès A du CGI, la date d’émission de la facture constitue une mention légale obligatoire et doit donc
            être exacte et correspondre à la date d’envoi effectif de la facture à son destinataire. En outre, l’envoi avec retard d’une facture par rapport à la date
            qui s’y trouve apposée est source d’erreurs et en compromet donc le bon traitement. En conséquence, toute facture enregistrant un décalage de plus
            de 7 jours calendaires entre la date qui s’y trouve apposée et la date à laquelle elle est reçue sera retournée au fournisseur pour mise en conformité de
            sa date d’émission et son paiement n’interviendra qu’après réception de la facture
            rectifiée. »</em></p>
        <p><em>« Le fournisseur a l’obligation de délivrer sa facture dès que la Fourniture et les éventuelles prestations de service associées ont été exécutées et s’y
            engage expressément, les présentes conditions valant demande de facturation dès l’exécution de la vente ou de la prestation de service qui
            constituent la Fourniture.»</em></p>
    </div>
    <div class="mx-5" *ngIf="lngCode=='EN'">
        <p><em>« It is recalled that under the terms of Article 242 noniès A of the CGI, the date of issue of the invoice constitutes a mandatory legal notice 
            and must therefore be accurate and correspond to the date on which the invoice is actually sent to its addressee. 
            In addition, sending an invoice late in relation to the date affixed to it is a source of errors and therefore compromises its proper processing. 
            Consequently, any invoice recording a delay of more than 7 calendar days between the date affixed to it and the date on which it is received 
            will be returned to the supplier for compliance with its date of issue and its payment will only be made after receipt of the invoice  rectified. »</em></p>
        <p><em>« The supplier is obliged to issue its invoice as soon as the Supply and any associated services have been performed and expressly undertakes to do so, 
            these conditions being equivalent to a request for invoicing as soon as the sale or provision of the service that constitutes the Supply is executed»</em></p>
    </div>

    <div class="mt-5 mb-3" style="width:100%; border-bottom:solid 1px red;">
        <h5>
            <strong *ngIf="lngCode=='FR'">MENTIONS LEGALES</strong>
            <strong *ngIf="lngCode=='EN'">LEGAL NOTICES</strong>
        </h5>
    </div>
    <div class="mx-5">
        <p *ngIf="lngCode=='FR'">
            <em>
                « Conformément à la loi Informatique et libertés du 6 janvier 1978 modifiée et au Règlement européen 2016/679 du 27 avril 2016, vous bénéficiez
                d’un droit d’accès, de rectification, d’effacement, de limitation, de portabilité des données personnelles vous concernant. Pour exercer ces droits, il
                suffit de vous adresser à votre interlocuteur habituel au sein d’ENDEL ou d’en faire la demande par voie électronique : <a href="mailto://dpm@altradendel.com">dpm@altradendel.com</a> ou
                par voie postale : Direction juridique ENDEL (RGPD), Bâtiment Fitzgerald, 165 Boulevard de Valmy – 92700 Colombes.  »
            </em>
        </p>
        <p *ngIf="lngCode=='EN'">
            <em>
                « In accordance with the French Data Protection Act of 6 January 1978, as amended, and the European Regulation 2016/679 of 27 April 2016, 
                you have the right to access, rectify, delete, limit and transfer personal data concerning you. To exercise these rights, 
                simply contact your usual contact person at ENDEL or make a request electronically : <a href="mailto://dpm@altradendel.com">dpm@altradendel.com</a> or 
                by post: ENDEL Legal Department (GDPR), Fitzgerald Building, 165 Boulevard de Valmy – 92700 Colombes.   »
            </em>
        </p>
    </div>
    <BR />
    <div style="width: 100%;" class="text-center">
        <button type="button" class="btn btn-primary" paflabel="Fermer" (click)="btnCloseClick()"></button>
    </div>
</div>